export default {
  simulation: {
    header: 'Simulation',
    secondsPerCalculationStepLabel: 'Resolution',
    secondsPerCalculationStepDescription: 'Simulated time between two consecutive calculation steps',
    factorOnCBetaLabel: 'Factor on C-Beta',
    factorOnCBetaDescription: 'Adjust carbon transfer coefficient',
    factorOnCDiffCoeffLabel: 'Factor on C-Diff-Coeff',
    factorOnCDiffCoeffDescription: 'Adjust carbon diffusion coefficient',
    timeoutSeconds: 'Max simulation time',
  },
  lowPressureCarburizingOnly: {
    header: 'Low-Pressure Carburizing only',
    maxCInCementiteLabel: 'Max C in Cementite',
    maxCInCementiteDescription: 'Upper limit for auto boost hysteresis',
    cBelowCarbidelimitLabel: 'C Below Carbidelimit',
    cBelowCarbidelimitDescription: 'Lower limit for auto boost hysteresis',
  },
  showComponentSelectionWhenLoadingCheckbox: 'Show component selection when loading',
};
